import { Box, FormControlLabel, Typography, styled } from '@material-ui/core';

export const OptionContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
}));

export const ProgressBarWrapper = styled(Box)(() => ({
  width: '50%',
  overflow: 'hidden',
  flexShrink: 0,
  justifyContent: 'flex-end',
  display: 'flex',
  height: '22px',
}));

export const ProgressBar = styled(Box)(({ theme }) => ({
  height: '100%',
  backgroundColor: '#E7EEFC',
  transition: 'width 0.3s ease',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  paddingRight: theme.spacing(1),
  borderRadius: '2px',
  padding: '4px',
}));

export const ProgressBarLabel = styled(Typography)({
  color: 'rgba(9, 34, 65, 0.7)',
  fontSize: '12px',
  fontWeight: 400,
});

export const StyledFormControlLabel = styled(FormControlLabel)({
  marginRight: 0,
  '& .MuiTypography-root': {
    fontSize: '12px',
    fontWeight: 400,
    width: '50%',
  },
});
